import { NgIf } from '@angular/common';
import { Component, input, InputSignal, output, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogConfig, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { FormioForm } from '@formio/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { ScwFormioBuilderComponent } from '../../../../shared/components/scw-formio-builder/scw-formio-builder.component';
import { EWorkInstructionEditorSidebar, IWorkInstructionEditor } from '../work-instructions.interface';
import { WorkInstructionStepsComponent } from './work-instruction-steps/work-instruction-steps.component';
import { IWorkInstructionStep, IStepForm } from './work-instruction-steps/work-instruction-steps.interface';
import { WorkInstructionTemplatesComponent } from './work-instruction-templates/work-instruction-templates.component';
import { IWorkInstructionTemplate } from './work-instruction-templates/work-instruction-templates.interface';

@Component({
  imports: [
    MatDrawerContainer,
    MatButton,
    MatDrawer,
    ReactiveFormsModule,
    MatIcon,
    MatDialogTitle,
    ScwFormioBuilderComponent,
    NgIf,
    WorkInstructionStepsComponent,
    TranslatePipe,
    WorkInstructionTemplatesComponent,
  ],
  selector: 'app-work-instruction-editor',
  styleUrl: './work-instruction-editor.component.scss',
  templateUrl: './work-instruction-editor.component.html',
})
export class WorkInstructionEditorComponent {
  public selectedWorkInstruction: InputSignal<IWorkInstructionEditor> = input.required();
  public editedForm = signal<FormioForm | undefined>(undefined);
  public drawerType = signal<EWorkInstructionEditorSidebar>(EWorkInstructionEditorSidebar.steps);
  public editedFormOfSteps = output<IStepForm[]>();

  public selectedStep: IWorkInstructionStep | undefined;
  protected readonly EWorkInstructionEditorSidebar = EWorkInstructionEditorSidebar;
  public readonly defaultForm: FormioForm = { components: [], display: 'form' };
  public initialForm: FormioForm = cloneDeep(this.defaultForm);
  public static readonly dialogConfig: MatDialogConfig = {
    disableClose: true,
    maxWidth: '95vw',
    restoreFocus: false,
    width: '95vw',
  };

  public openDrawer(drawer: MatDrawer, type: EWorkInstructionEditorSidebar): void {
    if (this.drawerType() !== type) {
      drawer.close();
    }

    drawer.toggle();

    this.drawerType.set(type);
  }

  public selectedWorkInstructionStep($event: IWorkInstructionStep): void {
    this.selectedStep = $event;
    this.initialForm = $event.form ?? cloneDeep(this.defaultForm);
  }

  public getEditedForm($event: FormioForm): void {
    this.editedForm.set($event);
  }

  public getEditedFormOfSteps($event: IStepForm[]): void {
    this.editedFormOfSteps.emit($event);
  }

  public applySelectedTemplate($event: IWorkInstructionTemplate): void {
    if (!$event.form) {
      return;
    }

    this.initialForm = $event.form;
    this.editedForm.set($event.form);
  }
}
